<template>
    <div class="selectProject-box">
        <HeaderNav
            header-title="选择合同信息"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <div class="search-con">
            <van-search
                placeholder="请输入搜索关键词"
                v-model="keywords"
                @search="onSearch"
            ></van-search>
        </div>
        <div class="project-list">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div
                    class="project-item"
                    v-for="(item, index) in contractList"
                    :key="index+item.cvid"
                    @click="chosedContract(item)"
                >
                    <ul>
                        <li>
                            <span class="icon icon1"></span>
                            <span>客户名称：{{ item.client_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">工程名称：{{ item.engineering_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">签订日期：{{ item.signing_date }}</span>
                        </li>
                        <li>
                            <span class="icon icon2"></span>
                            <span class="info">合同编号：{{ item.contract_number }}</span>
                        </li>
                    </ul>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            MobilePhone: '',
            pagetion: {
                pageindex: 0,
                pageSize: 4,
            },
            contractList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
            keywords: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 数据分页加载
        onLoad() {
            this.pagetion.pageindex++;
            this.getPage();
        },
        getPage() {
            if (this.MobilePhone) {
                const queryStr = '?keywords=' + this.keywords + '&phone=' + this.MobilePhone + '&pageindex='
                + this.pagetion.pageindex + '&pageSize=' + this.pagetion.pageSize;
                this.$axios
                    .get('/interfaceApi/sale/contract_manager/get_contract_client_phone_page' + queryStr)
                    .then(res => {
                        this.loading = false;
                        if (res.total) {
                            this.contractList = this.contractList.concat(res.rows);
                            if (this.contractList.length >= res.total) {
                                this.finished = true;
                            }
                        } else {
                            this.contractList = [];
                            this.finished = true;
                        }
                    }).catch(error => {
                        this.$toast(error.ErrorCode.Message);
                    });
            } else {
                this.loading = false;
                this.$toast('该账号手机号异常，请联系管理员！');
            }
        },
        // 搜索
        onSearch() {
            this.finished = false;
            this.loading = true;
            this.contractList = [];
            this.pagetion.pageindex = 0;
            this.onLoad();
        },
        // 通过code拉取字典信息
        getbycode(num) {
            return this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getbycode/' + num);
        },
        // 选中合同
        async chosedContract(data) {
            // if ((data.control_status === 2 || data.control_status === 3) && data.is_can_order === false) {
            //     this.$toast('当前合同已被管控，不能下单。管控原因：' + data.control_description);
            //
            //     return;
            // }
            this.formData.construction_method = data.construction_method;
            this.formData.contract_number = data.contract_number;
            this.formData.contract_type = data.contract_type;
            this.formData.contract_typename = data.contract_type_name;
            this.formData.contract_version = data.cvid;
            this.formData.fence_point = data.fence_point;
            this.formData.is_specify_monomer = data.is_specify_monomer;
            this.formData.project_code = data.engineering_number;
            this.formData.project_name = data.engineering_name;
            this.formData.project_type = data.engineering_type;
            this.formData.project_type_name = data.engineering_type_name;
            this.formData.project_address = data.engineering_location;
            this.formData.project_longitude = data.x_coordinate_point;
            this.formData.project_latitude = data.y_coordinate_point;
            this.formData.project_address1 = data.engineering_location;
            this.formData.project_longitude1 = data.x_coordinate_point;
            this.formData.project_latitude1 = data.y_coordinate_point;
            this.formData.station = data.supply_site;
            this.formData.station_name = data.supply_site_name;
            this.formData.supply_site = data.supply_site;
            this.formData.supply_site_name = data.supply_site_name;
            this.formData.customer_code = data.client_id;
            this.formData.customer_name = data.client_name;
            this.formData.customer_type = data.client_type;
            this.formData.customer_xydm = data.client_uscc;
            this.formData.dept_id = data.sales_dept_id;
            this.formData.company_id = data.company_id;
            this.formData.branch_id = data.branch_id;
            this.formData.employee_code = data.salesman_id;
            this.formData.employee_name = data.salesman_name;
            this.formData.employee_phone = data.salesman_phone;
            this.formData.haul_distance = data.haul_distance;
            this.formData.WantMaterialList = data.WantMaterialList;
            this.formData.is_dealer = data.is_dealer;
            this.formData.dealer_code = data.dealer_code;
            this.formData.sale_area_id = data.sale_area_id;
            this.formData.sale_method_code = data.sale_method_code;

            this.formData.order_type = data.order_type;
            this.formData.waiter_id = data.waiter_id;
            this.formData.waiter_name = data.waiter_name;

            this.formData.is_special_contract = data.is_special_contract;
            this.formData.gfdw_code = data.gfdw_code;
            this.formData.gfdw_name = data.gfdw_name;
            if (Number(this.$store.state.versionMark) === 2) {
                this.formData.sale_method_name = data.sale_method_name;
                this.formData.sale_area_name = data.sale_area_name;
                this.formData.sgdw_name = data.construction_enterprise;
                this.formData.sgdw_code = data.construction_uscc;
                // this.formData.section = data.section || '';
                // this.formData.section_id = data.section_id || '';
            }
            const res = await this.getbycode(data.contract_type);
            if (res) {
                this.formData.contract_type = data.contract_type;
                this.formData.contract_typename = res.name;
                this.$router.isBack = 1;
                if (data.is_specify_monomer) { // 属性为true 取合同的单体字段
                    this.$router.replace({
                        name: 'newMaterialPlan',
                        params: {
                            formData: this.formData,
                            type: 'selectedProjectCallBack',
                            monomer_ids: data.monomer_ids,
                            monomer_names: data.monomer_names,
                        },
                    });
                } else if (data.contract_type === '102-LS2') { // 零售合同回传要料人即客户联系人
                    this.$router.replace({
                        name: 'newMaterialPlan',
                        params: {
                            formData: this.formData,
                            type: 'selectedProjectCallBack',
                            client_contact_name: data.client_contact_name,
                            client_contact_phone: data.client_contact_phone,
                        },
                    });
                } else {
                    this.$router.replace({
                        name: 'newMaterialPlan',
                        params: {
                            formData: this.formData,
                            type: 'selectedProjectCallBack',
                        },
                    });
                }
                this.$router.go(-1);
            }
        },
        // 返回
        handleBack() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newMaterialPlan', params: { formData: this.formData } });
            this.$router.go(-1);
        },
    },
    created() {
        this.MobilePhone = this.$takeTokenParameters('MobilePhone');
        this.formData = this.$route.params.formData;
    },
    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.selectProject-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .project-item
            padding 12rpx
            background #fff
            margin 12rpx 12rpx 0 12rpx
            .icon
                width 18rpx
                height 18rpx
                display inline-block
                vertical-align middle
                margin-right 10rpx
                &:before
                    content ' '
                    width 16rpx
                    height 16rpx
                    display inline-block
                    background-repeat no-repeat
                    background-size 100% 100%
                &.icon1
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_3.png)
                &.icon2
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_1.png)
                &.icon3
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_8.png)
            .info
                color #666666
                font-size 14rpx
            li
                margin-bottom 10rpx
</style>
